module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "svg-blob-one",
    attrs: {
      "width": "600",
      "height": "600",
      "viewBox": "0 0 600 600",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(300,300)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M50.6,-82.6C76.4,-62.2,115.5,-66.4,129.4,-53.9C143.3,-41.3,132.1,-12,142.8,31.5C153.6,74.9,186.4,132.4,175.1,159.7C163.9,187.1,108.6,184.2,64.7,177.5C20.8,170.8,-11.6,160.2,-32.9,140.8C-54.2,121.4,-64.5,93.1,-104.2,74.9C-143.9,56.7,-213,48.7,-228.6,25C-244.2,1.4,-206.2,-37.7,-179.4,-75.9C-152.6,-114,-136.8,-151.2,-108.8,-170.6C-80.7,-190,-40.4,-191.5,-14,-169.7C12.4,-148,24.9,-103,50.6,-82.6Z",
      "fill": "#fff"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a32d58c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/Services/blob.vue
// module id = 482
// module chunks = 0